import React from "react";
import {Nav, NavItem, Navbar, NavDropdown, MenuItem} from 'react-bootstrap';
import "./nav.css";

export default class Navigation extends React.Component {
    render() {
        return (
            <Navbar collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a className="header-brand" href="#brand">Adél Apartman</a>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        <NavItem eventKey={1} href="#about">
                            Leírás
                        </NavItem>
                        <NavItem eventKey={2} href="#gallery">
                            Galéria
                        </NavItem>
                        <NavItem eventKey={4} href="#map">
                            Kapcsolat
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/nav/nav.js